import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'lgv-organisation-more-table-item',
  template: `
    <button mat-icon-button color="primary" [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #menu="matMenu" xPosition="before">
      <button mat-menu-item (click)="editClicked.emit()">
        <mat-icon class="material-icons-outlined">edit</mat-icon>
        <span translate>shared_component_generictable_edit</span>
      </button>
      <button mat-menu-item (click)="deleteClicked.emit()">
        <mat-icon class="material-icons-outlined">delete</mat-icon>
        <span translate>shared_component_generictable_delete</span>
      </button>
      <button mat-menu-item (click)="permissionClicked.emit()">
        <mat-icon class="material-icons-outlined">lock</mat-icon>
        <span translate>shared_component_generictable_permission</span>
      </button>
    </mat-menu>
  `,
  standalone: false,
})
export class OrganisationMoreTableItemComponent {
  @Output() editClicked = new EventEmitter<void>();
  @Output() deleteClicked = new EventEmitter<void>();
  @Output() permissionClicked = new EventEmitter<void>();
}
